/* Created by Mauget on 2018-03-30 */
import constants from 'Constants.js';

class PopupWrapperService {

    // Try to pop the winPath in a browser tab or new window. If we didn't get a popup, call it a blocked popup.
    static windowOpen(winPath, winName = '', winFeature = '', replace = false) {

        const popup = window.open(winPath, winName, winFeature, replace);

        if (!popup) {
            window.alert(constants.POPUP_BLOCKER_MESSAGE);
        }
        return popup;
    }

}

export default PopupWrapperService;